module.exports = __webpack_public_path__ + "img/plus-sign.19556087.svg";